import { render } from "./ResetButtonSingle.vue?vue&type=template&id=52c6de48&scoped=true"
import script from "./ResetButtonSingle.vue?vue&type=script&lang=js"
export * from "./ResetButtonSingle.vue?vue&type=script&lang=js"

import "./ResetButtonSingle.vue?vue&type=style&index=0&id=52c6de48&scoped=true&lang=css"

import exportComponent from "/home/adelaplace/PycharmProjects/smartcast/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c6de48"]])

export default __exports__